import { render, staticRenderFns } from "./CustomSnackBar.vue?vue&type=template&id=2fadda5c&scoped=true"
import script from "./CustomSnackBar.vue?vue&type=script&lang=js"
export * from "./CustomSnackBar.vue?vue&type=script&lang=js"
import style0 from "./CustomSnackBar.vue?vue&type=style&index=0&id=2fadda5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fadda5c",
  null
  
)

export default component.exports